import { EXTRALARGE, SMALL } from "shared/variables";
import { MaxWidth } from "components/MaxWidth";
import { Page } from "components/Page";
import { PageTitleWithLabel } from "components/PageTitleWithLabel";
import { ReviewForm } from "components/ReviewForm";
import { SpacingSection } from "components/SpacingSection";

export const ReviewsFormPage = ({ doc, preview }) => {
  const { type, uid } = doc;
  const { seo_title, seo_description, seo_image, hero_title } = doc.data;

  return (
    <Page
      title={seo_title}
      description={seo_description}
      image={seo_image}
      preview={preview}
    >
      <SpacingSection size={EXTRALARGE}>
        <MaxWidth>
          <PageTitleWithLabel
            title="Plaats een review"
            label={hero_title?.replace(/\*/g, "")}
            link={doc}
          />
          <SpacingSection size={SMALL}>
            <ReviewForm type={doc.type} uid={doc.uid} />
          </SpacingSection>
        </MaxWidth>
      </SpacingSection>
    </Page>
  );
};
